export default __webpack_public_path__ + "static/media/textToHTMLHome.f5ed0da3.png";